<template>
  <div v-if="hasExercisesAccess" class="first-container">
    <div id="main-container">
      <LoadingForum v-if="isLoading" ref="loader" @loaded="finishLoading" :message="loadingMessage" />
      <div class="basic-iframe-container-main" v-if="is_basic_user && user_info_is_loaded" :class="{ 'loading-hidden': isLoading, 'loading-visible': !isLoading }">
        <div class="mdc-layout-grid__cell--span-12 cell-container">
          <div class="basic-iframe-container">
            <iframe name="basic-exercises" id="basic-exercises-id" style="overflow:hidden" width="100%" height="100%" frameBorder="0" @load="handleIframeLoad"></iframe>
          </div>
        </div>
      </div>
      <div v-else class="mdc-layout-grid__cell--span-12 advanced-exercises-container" :class="{ 'loading-hidden': isLoading, 'loading-visible': !isLoading }">
        <div class="iframe-container">
          <iframe name="exercises" id="exercises-id" style="overflow:hidden" width="100%" height="100%" frameBorder="0" @load="handleIframeLoad"></iframe>
        </div>
      </div>
    </div>
  </div>
  <ToolAccessState
    v-else-if="_g_HasAppSession"
    title="Ejercicios no incluidos"
    message="Tu plan actual no incluye acceso a los ejercicios interactivos."
  />
  <ToolAccessState
    v-else
    title="Ejercicios interactivos"
    message="Inicia sesión para acceder a los ejercicios interactivos."
    anonymous
  />
</template>

<script>
import APICaller from "@/shared/mixins/APICaller.js";
import LoadingForum from '@/features/stockchart/components/LoadingForum.vue';
import ToolAccessState from "@/shared/components/common/ToolAccessState.vue";
//import BasicExercises from '@/features/education/components/exercises/BasicExercises.vue';
//import AvancedExercises from '@/features/education/components/exercises/AvancedExercises.vue';

import {mapGetters } from "vuex";
export default {
  mixins: [APICaller],
  name: 'Exercises',
  components: {
    LoadingForum,
    ToolAccessState
  },
  data() {
    return {
      is_basic_user: false,
      user_info_is_loaded: false,
      basic_user_uid: "",
      isLoading: true,
      loadingMessage: "Cargando ejercicios..."
    };
  },
  
  created(){
    this._getUID();
    var userInfoInterval = setInterval(() => {
      if(this.basic_user_uid != ""){
        this._getUserInfo();
        clearInterval(userInfoInterval);
      }
    }, 250);
  },

  mounted() {
    if (!this.hasExercisesAccess) {
      return;
    }

    this._setIframe();
    if (this._g_User.is_basic_user === true) {
      var isIframeLoaded = setInterval(() => {
        if(document.getElementById("basic-exercises-id") != null && document.getElementById("basic-exercises-id") != undefined){
          this._setBasicIframe();
          clearInterval(isIframeLoaded);
        }
      }, 250);
    }
  },
  computed:{
    ...mapGetters(["_g_HasAppSession", "_g_User", "_g_UserFeatures"]),
    hasExercisesAccess() {
      const permissions = (this._g_UserFeatures && this._g_UserFeatures.permissions) || {};
      return permissions.exercises === true || this._g_User.is_pre_eureker_user === true || this._g_UserFeatures.is_pre_eureker_user === true;
    },
  },
  methods: {
    finishLoading() {
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    
    handleIframeLoad() {
      // Check if we have a valid iframe with src attribute
      const iframe = this.is_basic_user ? 
        document.getElementById("basic-exercises-id") : 
        document.getElementById("exercises-id");
      
      if (iframe && iframe.src && iframe.src.trim() !== '') {
        if (this.$refs.loader) {
          this.$refs.loader.finishLoading();
        }
      }
    },

    _redirectToLogin() {
        window.location.href = "/user/login"; // Reemplaza la URL con la que desees redirigir
      },

    /* Basic user role */
    _getUID(){
      this.basic_user_uid = this._g_User.uid;
      this.user_info_is_loaded = true;
    },

    _getUserInfo(){
      this.is_basic_user = this._g_User.is_basic_user;
      this.user_info_is_loaded = true;
    },

    _setIframe(){
      var ExercisesFrame = document.getElementById("exercises-id");
      if (ExercisesFrame) {
        ExercisesFrame.src = process.env.VUE_APP_API + '/ejercicios-avanzados';
      }
    },

    _setBasicIframe(){
      var basicExercisesFrame = document.getElementById("basic-exercises-id");
      if (basicExercisesFrame) {
        basicExercisesFrame.src = process.env.VUE_APP_API + '/ejercicios';
      }
    },

  }
}
</script>



<style lang="scss" scoped>

  .first-container{
    height: 100%;
  }

  #main-container{
    height:100%;
    width:100%;
    overflow:hidden !important;
  }

  .iframe-container{
    height:100% !important;
  }

  .basic-iframe-container-main,
  .basic-iframe-container,
  .cell-container,
  .advanced-exercises-container{
    height: 100% !important;
  }
  
  header{
    display:none !important;
  }

  .container-image{
    /* Aplica un margen automático para centrar el div horizontalmente */
    margin: 0 auto;
    /* Ajusta el ancho máximo del contenedor */
    max-width: 800px;
    max-height: auto;
    
  }



  .container-image img{
    max-width: 500px;   
    max-height: 800px;
    margin: 20px;
    border-radius: 5px;
  }

  @media screen and (min-width: 768px) {
    .container-image img {
      width: 500px;
    }
  }

  .text-center {
    text-align: center;
    margin: 20px;
  }

  .container-image p {    
    text-align: justify;
  }

  .login-button{
    color: white;
    background-color: #00add8;
    border-radius: 20px;
    cursor: pointer;
    padding: 10px;
    text-decoration: none;
    border: none;
    outline: none;
    width: 150px;
    margin-top: 20px;
    font-size: 14px;
  }
  .login-button:hover{
    background-color: #00bdec;
  }

  .not-allowed-exercises-container{
    text-align: center;
    margin-top: 50px;
  }
  
  .link-to-store{
    color: #35add8 !important;
  }

  .not-allowed-exercises-title{
    color: #FF9B00;
    font-weight: bold;
  }

  /* Initially hide the main content but keep it rendered */
  .basic-iframe-container-main,
  .advanced-exercises-container {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  /* When loading finishes, fade it in */
  .loading-visible {
    opacity: 1;
  }

  /* Keep it hidden during loading */
  .loading-hidden {
    opacity: 0;
  }

</style>
